const countParams = {
  state: {
    // start_time:'',
    // end_time:'',
    time: [],
    workcode: [],
    page: 1,
    page_size: 10,
    // date:[],
    // person:'',
    panelName: 'first',
    departmentTime: [] // 部门统计选择时间
  },
  mutations: {
    set: (state, data) => {
      // state.start_time = data.start_time
      // state.end_time = data.end_time
      state.time = data.time
      state.workcode = data.workcode
      state.page = data.page
      state.page_size = data.page_size
    },
    reset: (state) => {
      // state.start_time = ''
      // state.end_time = ''
      state.time = []
      state.workcode = []
      state.page = 1
      state.page_size = 10
    },
    // setDate: (state, data) => {
    //   state.date = data.date
    //   state.person = data.person
    // },
    // resetDate: (state) => {
    //   state.date = []
    //   state.person = ''
    // }
    setPanel: (state, type) => {
      state.panelName = type
    },
    setTime: (state, data) => {
      state.departmentTime = data.time
    }
  },
  actions: {
    SET_PARAMS: ({ commit }, data) => {
      commit('set', data)
    },
    RESET_PARAMS: ({ commit }) => {
      commit('reset')
    },
    // SET_DATE: ({ commit }, data) => {
    //   commit('setDate', data)
    // },
    // RESET_DATE: ({ commit }) => {
    //   commit('resetDate')
    // }
    SET_PANELNAME: ({ commit }, type) => {
      commit('setPanel', type)
    },
    SET_DEPARTTIME: ({ commit }, time) => {
      commit('setTime', time)
    }
  }
}
export default countParams
